import React, { useEffect, useState, Fragment, useRef } from 'react';
import { Card, Container, Form, Button, Modal } from 'react-bootstrap'
import { useFormik } from 'formik'
import { Auth, LoadingComponent } from 'recupero-comunes'
import { CarpetaDigitalComponent } from 'recupero-caso-general';
import BitacoraGestion from '../../bitacora-gestion-recuperador';
import HeaderInfo from './header-info';
import FormAprobacionObjecion from './form-aprobacion-objecion';
import { serviceGetCfgForm, serviceProcesarRespuesta } from '../../../api/api-aprobacion-objecion';
import { serviceGetDatosImplicado } from '../../../api/api-recuperacion-cobro';
import { resetFormatoMonto, getBase64} from '../../../common/Formatos';
import { validationSchemasAprobacionObjecion } from '../../../common/validation-Schema-aprobacion-objecion';
import { useLocation, useNavigate } from 'react-router-dom';
import { obtenerDatosLlaves} from '../../../store/actions/encargado-cia-action'
import { useDispatch } from 'react-redux';
import Mensajes from '../../mensajes'

const FormPrincipal = ({ idCaso, idOrgCaso, idImplicado, idTareaWFL}) => {
    const dispatch=useDispatch()
    const history = useNavigate();
    const { state } = useLocation();
    const fileRef = useRef();
    const { rutUsuario } = Auth.currentUser();
    const queryState=JSON.parse(localStorage.getItem('filtrosRecuperoCias'));
    const [loading, setLoading] = useState(false);
    const [cfg_form, setCfg_form] = useState(null);

    const [implicado, setImplicado] = useState(null);
    const [contactoCIA, setContactoCIA] = useState("");
    const [estadoSituacion, setEstadoSituacion] = useState(null);
    const [glosaMotivo, setGlosaMotivo] = useState(null);

    const [responseData, setResponseData] = useState(null);
    const [showToast, setShowToast] = useState(false);

    const [showCarpeta, setShowCarpeta] = useState(false);
    const [showBitacora, setShowBitacora] = useState(false);
    const handleCloseCarpeta = () => setShowCarpeta(false);
    const handleCloseBitacora = () => setShowBitacora(false);

    const [clasRespuesta, setClasRespuesta] = useState(null);
    const [codClasCaso, setCodClasCaso] = useState("");
    const [destinatarios, setDestinatarios] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [glosaTipoDestinatarioModal, setGlosaTipoDestinatarioModal] = useState("");
    const [validaAbogados, setValidaAbogados] = useState(false);
    const [esCargaIndependiente, setEsCargaIndependiente] = useState(false);
    const [uploadSuccessTrigger, setUploadSuccessTrigger] = useState(0);
    const [showConfirmSinComentario, setShowConfirmSinComentario] = useState(false);
    const pendingDataRef = useRef(null);

    useEffect(() => {     
        dispatch(obtenerDatosLlaves({"idCaso":idCaso,"idImplicado":idImplicado,"idOrgCaso":idOrgCaso}));    
    }, [dispatch])

    useEffect(() => {
        getCfgForm();
        getDatosImplicado();
    }, [])

    const getCfgForm = async () => {
        const query = Buffer.from(JSON.stringify({ rutcia: idOrgCaso, idform: 59 })).toString('base64');
        const response = await serviceGetCfgForm(query);

        setCfg_form(response);
    }

    const getDatosImplicado = async () => {
        const query = Buffer.from(JSON.stringify({ idCaso: idCaso, idImplicado: idImplicado })).toString('base64');
        const response = await serviceGetDatosImplicado(query);

        const destinatarioAux = response[0]?.DestinatarioCIA ?? "";
        const destinatarioEmailAux = response[0]?.EmailDestinatarioCIA ?? "";

        setImplicado(response && response.length > 0 ? response[0] : null);
        setContactoCIA(`${destinatarioAux} - ${destinatarioEmailAux}`);
        setCodClasCaso(response[0]?.codClasCaso);
    }

    const handleCloseToast = () => {
        setShowToast(false);
        if (responseData?.code === 1) {
            if (esCargaIndependiente) {
                fileRef.current.value = "";
                formik.setFieldValue('file', undefined);
            } else {
                formik.resetForm(); fileRef.current.value = ""; setEstadoSituacion(null); goAreaTrabajo();
            }
        }
        setEsCargaIndependiente(false);
    }

    const goAreaTrabajo = () => { history('/area-trabajo-recupero-companias', { state: { queryState } }) };

    const postProcesarRespuesta = async (data, onSuccess) => {
        setLoading(true)
        const response = await serviceProcesarRespuesta(data);
        setResponseData(response);
        setLoading(false);
        setShowToast(true);
        if (response?.code === 1 && onSuccess) onSuccess();
    }

    const handleCargaDocumento = () => {
        const file = formik.values.file;
        if (!file) return;

        const body = {
            accion: 'cargarDocumento',
            idCaso,
            idImplicadoCaso: idImplicado,
            idOrganizacion: idOrgCaso,
            idUsuario: rutUsuario,
        };

        setEsCargaIndependiente(true);
        getBase64(file).then((base64data) => {
            const fileData = base64data.split(',')[1];
            postProcesarRespuesta(
                { ...body, filename: file.name, mimetype: file.type, base64data: fileData },
                () => setUploadSuccessTrigger(prev => prev + 1)
            );
        });
    }
    const ejecutarEnvioRespuesta = (dataResult, file) => {
        let destTOList = {codTipoDestinatario: 0};
        estadoSituacion.envCorreoRpta ? destTOList = destinatarios.find(({ codClasDestino }) => codClasDestino == "270001") : destTOList;
        if (destTOList && destTOList.codTipoDestinatario == estadoSituacion.tipoDestinatarioTO) {
            if (file) {
                getBase64(file).then((base64data) => {
                    const fileData = base64data.split(',')[1];
                    postProcesarRespuesta({ ...dataResult, filename: file.name, mimetype: file.type, base64data: fileData });
                });
            } else {
                postProcesarRespuesta(dataResult);
            }
        } else {
            setGlosaTipoDestinatarioModal(estadoSituacion.glosaTipoDestinatarioTO);
            setShowModal(true);
        }
    }

    const hoy=()=>{
        const fecha=new Date()
        const hoy=fecha.toISOString().split("T")[0] 
        return hoy
      }
    const formik = useFormik({
        initialValues: {
            clasificaRespuesta: "",
            motivoRespuestaCIA: "",
            fechaRespuesta: hoy(),
            porcConvenio: "",
            comentarioAnalista: "",
            montoRecobro: "",
            montoNetoApr: "",
            tipoSiniestroIM:"",
            abogado:"",
            correlativoSura: ""
        },
        validationSchema: validationSchemasAprobacionObjecion(clasRespuesta, validaAbogados),
        onSubmit: async (data) => {
            //setLoading(true);
            let dataResult = { ...data };

            dataResult.idCaso = idCaso;
            dataResult.idOrganizacion = idOrgCaso;
            dataResult.idImplicadoCaso = idImplicado;
            dataResult.idUsuario = rutUsuario;
            dataResult.ciaImplicado = implicado?.CiaImplicado;
            dataResult.idCiaImplicado = implicado?.IdCiaImplicado;
            dataResult.porcConvenioOld = implicado?.PorConvenido;

            dataResult.estadoRespuesta = estadoSituacion?.estadoRpta;
            dataResult.accionRespuesta = estadoSituacion?.accionRpta;
            dataResult.glosaEstadoRespuesta = estadoSituacion?.glosaEstado;
            dataResult.correlativoSuraOld = implicado?.CorrelativoCia;

            dataResult.fechaRespuesta = data.fechaRespuesta.split('-').join('');
            dataResult.montoRecobro = Number(resetFormatoMonto(data.montoRecobro));
            dataResult.montoNetoApr = Number(resetFormatoMonto(data.montoNetoApr));
            dataResult.glosaMotivo = glosaMotivo;
            dataResult.idTareaWFL = idTareaWFL;

            if (!data.comentarioAnalista) {
                pendingDataRef.current = { dataResult, file: data.file };
                setShowConfirmSinComentario(true);
                return;
            }
            ejecutarEnvioRespuesta(dataResult, data.file);
        }
    })

    return (
        <Fragment>
            <LoadingComponent show={loading} />

            <Card>
                <Card.Header as='h6' style={{ backgroundColor: "#4F517A", color: '#FFFFFF' }}>
                    {cfg_form && cfg_form["aprobobjcartacobrotercero-title"]}
                    {` (${implicado?.IdImplicado}: ${implicado?.NombreImplicado} - ${implicado?.Patente})` }
                </Card.Header>

                <Card.Body>
                    <HeaderInfo
                        cfg_form={cfg_form}
                        idCaso={idCaso}
                        idOrgCaso={idOrgCaso}                        
                        implicado={implicado}
                        codClasCaso= {codClasCaso}
                        getDatosImplicado={getDatosImplicado}
                    />
                </Card.Body>
            </Card>
            <Form onSubmit={formik.handleSubmit} className='mt-2 mb-4'>
                <Card>
                    <Card.Body>
                        <FormAprobacionObjecion
                            cfg_form={cfg_form}
                            formik={formik}
                            contactoCIA={contactoCIA}
                            implicado={implicado}
                            estadoSituacion={estadoSituacion}
                            setEstadoSituacion={setEstadoSituacion}
                            setGlosaMotivo={setGlosaMotivo}
                            setClasRespuesta = {setClasRespuesta}
                            fileRef={fileRef}
                            idCaso={idCaso}
                            destinatarios={destinatarios}
                            setDestinatarios={setDestinatarios}
                            setValidaAbogados={setValidaAbogados}
                            handleCargaDocumento={handleCargaDocumento}
                            uploadSuccessTrigger={uploadSuccessTrigger}
                        />
                    </Card.Body>
                    {showToast && 
                        <Mensajes
                            showToast={showToast}
                            handleCloseToast={handleCloseToast}
                            delay={5000}
                            responseData={responseData}
                        ></Mensajes>
                    }
                    <Card.Footer style={{ display: 'flex', justifyContent: 'right' }}>
                        <Button className='m-2' variant='outline-info' onClick={goAreaTrabajo}>
                            {cfg_form && cfg_form["aprobobjcartacobrotercero-btn-volver"]}
                        </Button>
                        <Button className='m-2' variant='carpeta' onClick={() => setShowCarpeta(true)}>
                            {cfg_form && cfg_form["aprobobjcartacobrotercero-btn-carpeta"]}
                        </Button>
                        <Button className='m-2' variant='bitacora' onClick={() => setShowBitacora(true)}>
                            {cfg_form && cfg_form["aprobobjcartacobrotercero-btn-bitacora"]}
                        </Button>
                        <Button type="submit" className='m-2' variant='actualizar'>
                            {cfg_form && cfg_form["aprobobjcartacobrotercero-btn-procrpta"]}
                        </Button>
                    </Card.Footer>
                </Card>
            </Form>

            <BitacoraGestion
                handleCloseBitacora={handleCloseBitacora}
                showBitacora={showBitacora}
            />

            <Modal show={showCarpeta} onHide={handleCloseCarpeta} size="xl">
                <CarpetaDigitalComponent
                    handleClose={handleCloseCarpeta}
                    idCaso={idCaso}
                    idOrganizacionCaso={idOrgCaso}
                    idImplicado={idImplicado}
                    prototipo={2}
                />
            </Modal>
            <Modal show={showConfirmSinComentario} onHide={() => setShowConfirmSinComentario(false)} size='md'>
                <Card>
                    <Card.Header style={{ backgroundColor: '#4F517A', color: 'white' }}>Sin comentario analista</Card.Header>
                    <Card.Body>No ingresó comentario analista, ¿desea continuar?</Card.Body>
                    <Card.Footer style={{ display: 'flex', justifyContent: 'center', gap: '8px' }}>
                        <Button className='m-2 w-auto' variant='outline-secondary' onClick={() => setShowConfirmSinComentario(false)}>Cancelar</Button>
                        <Button className='m-2 w-auto' variant='actualizar' onClick={() => {
                            setShowConfirmSinComentario(false);
                            if (pendingDataRef.current) {
                                ejecutarEnvioRespuesta(pendingDataRef.current.dataResult, pendingDataRef.current.file);
                                pendingDataRef.current = null;
                            }
                        }}>Continuar</Button>
                    </Card.Footer>
                </Card>
            </Modal>

            <Modal show={showModal} onHide={() => setShowModal(false)} size='md'>
                <Card>
                    <Card.Header style={{ backgroundColor: '#4F517A', color: 'white' }}>Información</Card.Header>
                    <Card.Body>Destinatario TO, debe ser aquel que se encuentre clasificado como <strong>{glosaTipoDestinatarioModal}</strong>.</Card.Body>

                    <Card.Footer style={{ display: 'flex', justifyContent: 'center' }}>
                        <Button className='m-2 w-auto' variant='outline-info' onClick={() => setShowModal(false)}>Cerrar</Button>
                    </Card.Footer>
                </Card>
            </Modal>
            <style type='text/css'>
                {`
                    .is_required:after {
                        content: "*";
                        margin-left: 2px;
                        color: #000;
                        font-weight: 500;
                        font-size: 12pt;
                    }
                    .label {
                        font-weight: bold;
                        font-size: 14px;
                    }
                    .btn-carpeta {
                        background-color: #D59B49;
                        color: #FFFFFF;
                        width: 140px;
                    }
                    .btn-carpeta:hover {
                        background-color:#e1b97f;
                        color: #FFFFFF;
                    }
                    .btn-bitacora {
                        background-color: #55B2CE;
                        color: #FFFFFF;
                        width: 140px;
                    }
                    .btn-bitacora:hover{
                        background-color: #87c9dc;
                        color: #FFFFFF;
                    } 
                    .btn-carta {
                        background-color:  #2E6EA5;
                        color: #FFFFFF;
                        width: 140px;     
                        padding:6px 0px 6px 0px;
                    }
                    .btn-carta:hover{
                        background-color:  #5b9ad1;
                        color: #FFFFFF;
                    }
                    .btn-actualizar {
                        background-color: #C14B49;
                        color: #FFFFFF;
                        width: 160px;
                    }
                    .btn-actualizar:hover{
                        background-color: #d3807f;
                        color: #FFFFFF;
                    }
                    .btn-volver {
                        color: #66CCCC;
                        border: 1px solid #C00
                        width: 140px;
                    }
                    .btn-tamano{
                        padding: 1rem 1.5rem;
                        font-size: 1.5rem;
                    }
                `}
            </style>
        </Fragment>
    )
}

export default FormPrincipal;